/**
 * QuickActionChips — clickable suggestion chips emitted by the agent via
 * XAVIOR_ACTIONS or the show_actions tool. The parent's `onSelect` receives
 * the FULL action object (not just the message string) so it can branch on
 * `kind` for chip-driven side-effects like demo.load, oauth.*, tour.end.
 */

export interface QuickAction {
  label: string
  message: string
  icon?: string
  variant?: 'primary' | 'outline'
  /** Optional side-effect tag the parent inspects (demo.load, oauth.google.email, tour.end, …). */
  kind?: string
}

interface QuickActionChipsProps {
  actions: QuickAction[]
  onSelect: (action: QuickAction) => void
}

export function QuickActionChips({ actions, onSelect }: QuickActionChipsProps) {
  if (actions.length === 0) return null

  return (
    <div className="quick-action-chips">
      {actions.map((action, index) => (
        <button
          key={`${action.label}-${index}`}
          type="button"
          className={`quick-action-chip${action.variant === 'primary' ? ' quick-action-chip--primary' : ''}`}
          onClick={() => onSelect(action)}
        >
          {action.icon && <span className="quick-action-chip-icon">{action.icon}</span>}
          {action.label}
        </button>
      ))}
    </div>
  )
}
